import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, RowNode } from '@ag-grid-community/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExpenseSourceType } from '@services/gql.service';

interface AgExpenseDefaultsActionComponentParams extends ICellRendererParams {
  dragDropChangeFN: (params: { rowNode: RowNode }) => void;
  processing$?: Observable<boolean>;
}

@Component({
  templateUrl: 'ag-expense-defaults-drag.component.html',
  styleUrls: ['ag-expense-defaults-drag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgExpenseDefaultsDragComponent implements ICellRendererAngularComp {
  readonly bgClasses: string = 'border rounded-[5px] w-[120px] cursor-move';

  readonly txtClasses: string = 'max-w whitespace-nowrap overflow-hidden text-ellipsis';

  params!: AgExpenseDefaultsActionComponentParams;

  dataCheck$ = new BehaviorSubject(false);

  optionData = new BehaviorSubject<ExpenseSourceType[]>([]);

  lineData: ExpenseSourceType[] = [];

  refresh(): boolean {
    return false;
  }

  agInit(params: AgExpenseDefaultsActionComponentParams) {
    this.params = params;

    this.dataCheck$.next(!!this.params.data);
    if (this.params?.data?.sources) {
      this.lineData = [...this.params.data.sources];
      this.optionData.next(this.lineData);
    }
  }

  onDragDropChange(event: CdkDragDrop<string[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.lineData, event.previousIndex, event.currentIndex);
      if (this.params.dragDropChangeFN) {
        this.params.dragDropChangeFN({
          rowNode: {
            ...this.params.node,
            data: { ...this.params.node.data, sources: this.lineData },
          } as RowNode,
        });
      }
    }
  }

  get(timePeriod: ExpenseSourceType) {
    switch (timePeriod) {
      case ExpenseSourceType.EXPENSE_SOURCE_VENDOR_ESTIMATE:
        return {
          text: 'Vendor Estimate',
          bg: `border-aux-green-dark bg-aux-gray-dark-300 bg-opacity-25 ${this.bgClasses}`,
          txtClass: `text-aux-green-dark ${this.txtClasses}`,
        };
      case ExpenseSourceType.EXPENSE_SOURCE_FORECAST:
        return {
          text: 'Forecast',
          bg: `border-aux-blue bg-aux-blue-light bg-opacity-25 ${this.bgClasses}`,
          txtClass: `text-aux-blue ${this.txtClasses}`,
        };
      case ExpenseSourceType.EXPENSE_SOURCE_EVIDENCE_BASED:
        return {
          text: 'Evidence Based',
          bg: `border-aux-green-dark bg-white ${this.bgClasses}`,
          txtClass: `text-aux-green-dark ${this.txtClasses}`,
        };
      default:
        return { text: '', bg: '', txtClass: '' };
    }
  }

  noReturnPredicate() {
    return false;
  }
}
